import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_GORRILA_API,

  withCredentials: true,
});

export default instance;
